module.exports = __webpack_public_path__ + "img/news_banner_0.29d96cb4.jpg";